import { FilterButtonController } from "./button.controller";

angular
    .module("thor.shared.filter.button.component", [])
    .component("thorFilterButton", {
        bindings: {
            isFiltersDisplayed: "="
        },
        controller: FilterButtonController,
        template: require("../../shared/filter/button.html")
    });
